import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import IOSInstallPrompt from './IOSInstallPrompt'; // Import the iOS prompt
import { useTranslation } from 'react-i18next';
import logo from '../../utils/static/logo.png';

const Layout = ({ children, noPadding = false }) => {
  const { t } = useTranslation();
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallPromptVisible, setInstallPromptVisible] = useState(false);

  useEffect(() => {
    // 1. Detection: If already in standalone mode, don't show anything
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
      return;
    }

    // 2. Browser Install Prompt (Android/Chrome)
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setInstallPromptVisible(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    setInstallPromptVisible(false);
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    setDeferredPrompt(null);
  };

  return (
    <div className={`w-full flex flex-col bg-gray-50 ${noPadding ? 'h-screen overflow-hidden' : 'min-h-screen'}`}>
      
      {/* Header */}
      <div className="flex-none z-[3000] sticky top-0">
        <Navbar />
      </div>

      {/* Main Content */}
      <main className={`flex-grow relative flex flex-col ${noPadding ? 'h-full' : 'w-full'} md:pb-0 pb-20`}>
        {children}
      </main>

      {/* Android/Chrome Install Button — bottom-right on mobile, bottom-left on desktop */}
      {isInstallPromptVisible && (
        <button
          onClick={handleInstallClick}
          className="fixed z-[4000] flex items-center gap-2 rounded-full py-1 shadow-lg transition-shadow hover:shadow-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1d5cab] bottom-[168px] right-4 pl-3 pr-1 bg-gray-900/80 backdrop-blur-sm md:bottom-6 md:left-4 md:right-auto md:pl-1 md:pr-4 md:bg-white/95 md:border md:border-gray-200"
        >
          <span className="text-xs font-bold text-white md:text-gray-800 md:order-2">{t('buttons.install-app', 'Install App')}</span>
          <img src={logo} alt="" className="h-9 w-9 rounded-full object-cover md:order-1" />
        </button>
      )}

      {/* iOS Specific Prompt */}
      <IOSInstallPrompt />

      {/* Footer */}
      {!noPadding && <Footer />}
    </div>
  );
};

export default Layout;
